<template>
  <v-container id="data-tables" tag="section" fluid>
    <base-material-card color="primary" icon="mdi-badge-account" inline class="ml-0 px-5 py-3">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ title }}
        </div>
      </template>

      <v-btn color="success" dark elevation="1" class="mt-5" style="float: left" relative text medium @click="addUsuario">
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        NOVO USUÁRIO
      </v-btn>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search bs-usuarios ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <v-divider class="mt-10" />
      <v-data-table
        class="usuarios-table"
        :headers="headers"
        :options="options"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhum usuário disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nome }}
        </template>
        <template v-slot:[`item.email`]="{ item }">
          {{ item.email }}
        </template>
        <template v-slot:[`item.admin`]="{ item }">
          {{ item.admin ? 'SIM' : 'NÃO' }}
        </template>
        <template v-slot:[`item.perfil`]="{ item }">
          <v-tooltip bottom :disabled="item.perfil ? true : false">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                {{ item.perfil ? item.perfil : '-' }}
              </div>
            </template>
            <span>
              Não foi possível identificar o perfil desse usuário pois ele não existe na empresa {{ nomeEmpresaConectada }}.
            </span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.desativado`]="{ item }">
          <usuarios-status :status="item.desativado ? 'Inativo' : 'Ativo'" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu v-if="userIsAdmin || (userIsManager && !item.admin)" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="blue-grey lighten-3" class="ml-1 px-2" min-width="0" small v-bind="attrs" v-on="on">
                <v-icon small>mdi-menu-down-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="userIsAdmin || (userIsManager && !item.admin)" @click="editarUsuario(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-pencil</v-icon>
                  Editar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="userIsAdmin" :disabled="loading" @click="openDialogChangeProfile(item)">
                <v-list-item-title>
                  <v-icon small :loading="loading">mdi-account-cog</v-icon>
                  Alterar Perfil
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </base-material-card>
    <usuarios-list-profiles
      :dialog.sync="dialog"
      :uid="dialogData.uid"
      :usuario="dialogData.usuario"
      :perfil="dialogData.perfil"
      :perfis="perfis"
      @click:save="alterarPerfil($event)"
    />
  </v-container>
</template>

<script>
  import PerfisService from '@/services/PerfisService';
  import UsuariosService from '@/services/UsuariosService';
  import Firestore from '@/Firestore.js';

  export default {
    components: {
      UsuariosStatus: () => import('@/components/usuarios/UsuariosStatus'),
      UsuariosListProfiles: () => import('@/components/usuarios/UsuariosListProfiles')
    },
    props: {
      items: {
        type: Array,
        default: () => []
      },
      userIsAdmin: {
        type: Boolean,
        default: false
      },
      userIsManager: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Tabela'
      }
    },
    emits: ['refresh'],
    data: () => ({
      search: undefined,
      headers: [
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Email',
          value: 'email'
        },
        {
          text: 'Admin',
          value: 'admin'
        },
        {
          text: 'Perfil',
          value: 'perfil'
        },
        {
          text: 'Status',
          value: 'desativado'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-3'
        }
      ],
      options: {
        sortBy: ['nome', 'desativado'],
        multiSort: false
      },
      perfis: [],
      dialogData: { uid: '', usuario: '', perfil: '' },
      dialog: false,
      loading: false,
      empresas: []
    }),
    computed: {
      nomeEmpresaConectada() {
        return this.$store.getters.getEmpresa.toUpperCase();
      }
    },
    created() {
      this.getPerfis();
      this.getEmpresas();
    },
    methods: {
      editarUsuario(id) {
        this.$router.push('/administracao/usuarios/edit/' + id);
      },
      addUsuario() {
        this.$router.push('/administracao/usuarios/edit/');
      },
      getPerfis() {
        this.loading = true;
        PerfisService.getAll()
          .then((response) => (this.perfis = response.data.data))
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar perfis de usuários.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      },
      openDialogChangeProfile(item) {
        if (!item.perfil) {
          this.$toast.warning(
            `Impossível editar o perfil, pois esse usuário não existe na empresa ${this.nomeEmpresaConectada}.`,
            '',
            { position: 'topRight' }
          );
          this.dialogData = { uid: '', usuario: '', perfil: '' };
          this.dialog = false;
        } else {
          this.dialogData = { uid: item.id, usuario: item.nome, perfil: item.perfil };
          this.dialog = true;
        }
      },
      async alterarPerfil(userInfo) {
        this.loading = true;
        let requests = [];
        if (process.env.NODE_ENV === 'production') {
          this.empresas.forEach((empresa) => {
            const baseUrl = `https://${empresa.url}.gestaohexa.com.br/api`;
            requests.push(this.alterarPerfilUsuario(userInfo, baseUrl, empresa.sigla));
          });
        } else {
          requests.push(this.alterarPerfilUsuario(userInfo, process.env.VUE_APP_API_BASE_URL, 'AMBIENTE-LOCAL'));
        }

        /* Espera todas as requests terminarem */
        await Promise.all(requests)
          .then(() => {
            this.$toast.success(`Perfil do usuário [${userInfo.usuario}] editado com sucesso`, '', { position: 'topRight' });
          })
          .finally(() => {
            this.$emit('refresh', true);
            this.loading = false;
            this.dialog = false;
          });
      },
      getEmpresas() {
        this.empresas = [];
        return Firestore.collection('empresas')
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              this.empresas.push({
                id: doc.id,
                url: doc.data().url,
                sigla: doc.data().sigla,
                nome: doc.data().nome
              });
            });
          });
      },
      alterarPerfilUsuario(postData, baseURL, siglaEmpresa) {
        return UsuariosService.alterarPerfilUsuario(postData, baseURL)
          .then(() => {
            console.log(`[${siglaEmpresa}] :: Perfil do usuário [${postData.usuario}] editado com sucesso`);
          })
          .catch((err) => {
            if (err?.data?.error_code == 120) {
              this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
              console.error(err.data.erro);
            } else {
              this.$toast.error(`[${siglaEmpresa}] :: Falha ao alterar perfil do usuário [${postData.usuario}]`, '', {
                position: 'topRight'
              });
              console.error(err);
            }
            throw new Error(err.data);
          });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .usuarios-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .usuarios-table table tr td:nth-child(4),
    .usuarios-table table tr td:nth-child(5) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 480px) {
    .bs-usuarios {
      width: 180.22px !important;
    }
  }
</style>